import { render } from "./MeetingTranscription.vue?vue&type=template&id=1fe1d96b&scoped=true"
import script from "./MeetingTranscription.vue?vue&type=script&lang=js"
export * from "./MeetingTranscription.vue?vue&type=script&lang=js"

import "./MeetingTranscription.vue?vue&type=style&index=0&id=1fe1d96b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe1d96b"]])

export default __exports__